
(function ( $ ) {

    "use strict";

    var isDesktop = !('ontouchstart' in window);

    $.fn.responsiveNavigation = function(options) {

        // Set default parameters
        var settings = $.extend({
            class     : "cf",
            breakPoint: 768
        }, options);

        var menu = $(this),
            navEnable = false;

        // Create navigation container
        menu.wrap('<nav id="nav-main" class="responsive-naviation"></nav>');

        // Add classes to the container
        if ( settings.class.length > 0 ) {
            menu.parent('.responsive-naviation').addClass(settings.class);
        }

        // Create trigger button
        menu.before('<button class="menu-trigger hamburger hamburger--squeeze" type="button"><span class="hamburger-box"><span class="hamburger-inner"></span></span><span class="hamburger-label">MENU & SHOP</span></button>');

        function hoverNavMenuDesktop() {
          $('.menu-item-has-children').hover( function() {
            $( this ).children('.sub-menu').stop( true, false ).fadeIn(200);
          }, function() {
            $( this ).children('.sub-menu').stop( true, false ).fadeOut(200);
          });
        }

        function unbindHoverDesktop() {
          $( '.menu-item-has-children' ).off( "mouseenter mouseleave" );
        }
        // Add hover effect
        if (window.innerWidth > settings.breakPoint) {
          hoverNavMenuDesktop();
        }

        if (window.innerWidth < settings.breakPoint) {
            $('.menu-trigger').show();
            menu.hide();
            navEnable = true;
        }

        $(window).resize(function() {
            if (window.innerWidth < settings.breakPoint) {
                $('.menu-trigger').show();
                if (!$('.menu-trigger').hasClass('is-active')) {
                    menu.hide();
                }
                navEnable = true;
                unbindHoverDesktop();
            } else {
                $('.menu-trigger').hide();
                $('.sub-menu').removeAttr('style');
                menu.show();
                navEnable = false;
                hoverNavMenuDesktop();
            }
        });

        $('.menu-item-has-children > a').append('<i class="icon-angle-down"></i>');


        $('.menu-trigger, .menu-item-has-children > a > i').on('click', function (event) {
            event.preventDefault();

            var $element = $(this);
            if ($(event.target).is('i')) {
                $element = $(this).parent();
            }

            if (navEnable) {
                if ($element.hasClass('is-active')) {

                    $element.removeClass('is-active');
                    $($element.siblings('ul, .navigation-container')).stop().slideUp(300, function() {

                        if ($element.hasClass('menu-trigger')) {
                            $.each($('.menu-primary').find('.is-active'), function(){
                              $element.siblings('.sub-menu').removeAttr('style');
                              $element.removeClass('is-active');
                          });
                        }

                    });

                } else {

                    $element.addClass('is-active');
                    $($element.siblings('ul, .navigation-container')).stop().slideDown(300);

                }
            }
        } );


        return this;
    };

} ( jQuery ));
